import { render, staticRenderFns } from "./InboundTimeReport.vue?vue&type=template&id=c22c5d38&"
import script from "./InboundTimeReport.vue?vue&type=script&lang=js&"
export * from "./InboundTimeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports